import axiosInstance from "@/api/axiosInstance";

export class BookingService {
  private readonly basePath: string;

  constructor(basePath = "/bookings") {
    this.basePath = basePath;
  }

  public async getAll(): Promise<any> {
    try {
      const url = `/api/v1${this.basePath}`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (e: unknown) {
      console.log("Bookings getall threw error", e);
    }
  }

  /** Errors propagate: the view classifies them and renders 403 / 404 / unavailable in place. */
  public async get(id: string): Promise<any> {
    const url = `/api/v1${this.basePath}/${id}`;
    const response = await axiosInstance.get(url);
    return response.data;
  }

  public async getVersions(id: string): Promise<any> {
    const url = `/api/v1${this.basePath}/${id}/versions`;
    const response = await axiosInstance.get(url);
    return response.data;
  }

  public async create(body: any): Promise<any> {
    try {
      const url = `/api/v1${this.basePath}`;
      const response = await axiosInstance.post(url, body);
      return response.data;
    } catch (e: unknown) {
      console.log("Creating booking threw error", e);
    }
  }

  public async update(body: any, publicReference: string): Promise<any> {
    const url = `/api/v1${this.basePath}/${publicReference}`;
    const response = await axiosInstance.put(url, body);
    return response.data;
  }

  public async hasBilledItems(publicReference: string): Promise<boolean> {
    const url = `/api/v1${this.basePath}/${publicReference}/has-billed-items`;
    const response = await axiosInstance.get(url);
    return response.data;
  }

  /**
   * Sets IFA on a single booking item in place. Unlike `update`, this does not create a new
   * booking version and leaves attached bills alone.
   */
  public async updateItemIfa(
    publicReference: string,
    itemId: number,
    body: { ifaAmount: number | null; ifaCount: number | null }
  ): Promise<any> {
    const url = `/api/v1${this.basePath}/${publicReference}/items/${itemId}/ifa`;
    const response = await axiosInstance.patch(url, body);
    return response.data;
  }

  public async updateStatus(
    publicReference: string,
    status: string
  ): Promise<any> {
    const url = `/api/v1${this.basePath}/${publicReference}/status`;
    const response = await axiosInstance.patch(url, { status });
    return response.data;
  }
}
